<template>
  <!-- DEBUG>Training.vue -->
  <div class="" v-if="isPropertyLoading || isUserLoading"><Loading /></div>
  <div v-else>
    <!-- DEBUG>Training.vue>property & user done loading -->
    <BethsLayout :layoutTitle="`Training - ${property?.name}`">
      <!-- DEBUG> Training.vue> Inside Training page content slot -->
      <div v-if="property?.isTrainingEnabled">
        <section class="welcome">
          <h1 class="text-2xl font-bold">Welcome, {{ user?.firstName }}</h1>
        </section>
        <div class="p-5 lg:px-12 text-sm lg:text-sectionHdr font-bold py-10">
          <div class="container mx-auto">
            <!-- TRAINING PROGRAMS -->
            <div
              class="mb-24"
              v-for="program in trainingPrograms"
              :key="program.trainingProgramId"
            >
              <div class="mb-8 lg:mb-12 col-span-2">
                <div class="flex">
                  <div class="whitespace-nowrap">{{ program.name }}</div>
                  <div class="flex flex-justify-between items-center w-full pl-5">
                    <img src="\images\Ellipse.png" alt="" />
                    <div class="bg-divider mt-0.5 h-0.5 w-full"></div>
                    <img src="\images\Ellipse.png" alt="" />
                  </div>
                </div>
              </div>

              <div class="flex-col lg:grid lg:grid-cols-3 lg:gap-0">
                <div class="h-48 w-80 lg:w-72 xl:w-80 rounded-lg shadow-lg relative">
                  <div
                    class="absolute top-6 w-28 h-6 bg-trainingStatus rounded-r-lg text-white text-yellowCardSm font-normal pl-4 pt-1"
                    v-if="
                      program.trainingModules
                        ?.filter((m) => m.isActive)
                        .every((m) =>
                          completedModules.find(
                            (cm) => cm.trainingModuleId === m.trainingModuleId
                          )
                        ) // Every module should be completed
                    "
                  >
                    Completed
                  </div>
                  <img
                    class="rounded-t-lg"
                    src="\images\yellowCardTraining1.png"
                    alt=""
                  />
                  <div class="h-1.5 mt-0.5 bg-yellowCard"></div>
                  <div class="text-yellowCardSm lg:text-sm pt-3 px-4 lg:pl-8 lg:pr-6">
                    <div class="font-bold">{{ program.name }}</div>
                  </div>
                </div>

                <div
                  class="hidden lg:block text-sm text-black font-normal order-last lg:ml-12 mt-4"
                >
                  <div>
                    <p>
                      This program provides essential information about your role in an
                      emergency. Each of the modules features a training video followed by
                      a brief quiz.
                    </p>
                    <p>
                      Please do not close the training video as the quiz will appear
                      automatically following the completion of the video program.
                    </p>
                  </div>
                  <div class="mt-3">
                    If you would like to review the material, you may watch the video
                    again before answering the test questions.
                  </div>
                  <div class="mt-3">
                    You may print a certificate of completion after passing the final
                    quiz.
                  </div>
                </div>

                <div class="mt-4">
                  <div
                    class="flex text-sm items-center py-2 pr-2 hover:bg-blue-50"
                    v-for="module in program.trainingModules?.filter((m) => m.isActive)"
                    :key="module.trainingModuleId"
                  >
                    <div class="m-1 p-1 overflow-visible align-middle shrink-0">
                      <img
                        :class="
                          completedModules.find(
                            (cm) => cm.trainingModuleId === module.trainingModuleId
                          )
                            ? ''
                            : 'invisible'
                        "
                        class="m-1 object-none align-middle"
                        :src="'/images/radioOn.png'"
                      />
                    </div>
                    <div
                      class="font-normal hover:text-blue-400 cursor-pointer font-module font-serif flex-grow"
                      :class="
                        completedModules.find(
                          (cm) => cm.trainingModuleId === module.trainingModuleId
                        )
                          ? 'text-disabled'
                          : 'text-link'
                      "
                      @click="moduleClick(module)"
                    >
                      {{ module.name }}
                    </div>
                    <button
                      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                      @click="moduleClick(module)"
                    >
                      Start
                    </button>
                  </div>
                  <div
                    v-if="
                      program.trainingModules
                        ?.filter((m) => m.isActive)
                        .every((m) =>
                          completedModules.find(
                            (cm) => cm.trainingModuleId === m.trainingModuleId
                          )
                        ) // Every module should be completed
                    "
                  >
                    <form action="/certificate/pdf" method="post" class="mt-8 flex my-4">
                      <input
                        type="hidden"
                        name="userName"
                        :value="user?.firstName + ' ' + user?.lastName"
                      />
                      <input type="hidden" name="propertyName" :value="property?.name" />
                      <input
                        type="hidden"
                        name="trainingProgramName"
                        :value="program.name"
                      />
                      <button
                        class="p-2 text-sm bg-blue-100 border rounded-md hover:bg-blue-200"
                        type="submit"
                      >
                        View Certificate
                      </button>
                    </form>
                  </div>
                </div>

                <div class="lg:hidden text-sm text-black font-normal order-last mt-10">
                  <div>
                    <p>
                      This program provides essential information about your role in an
                      emergency. Each of the modules features a training video followed by
                      a brief quiz.
                    </p>
                    <p>
                      Please do not close the training video as the quiz will appear
                      automatically following the completion of the video program.
                    </p>
                  </div>
                  <div class="mt-3">
                    If you would like to review the material, you may watch the video
                    again before answering the test questions.
                  </div>
                  <div class="mt-3">
                    You may print a certificate of completion after passing the final
                    quiz.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <h1>Training Not Enabled</h1>
      </div>
    </BethsLayout>
  </div>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";
import { TrainingModuleDTO } from "../store/generatedFetchClient";
import { useTrainingStore } from "../store/trainingStore";

const router = useRouter();
const bldgStore = useBldgStore();
const userStore = useUserStore();
const trainingStore = useTrainingStore();

var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);

var user = computed(() => userStore.user);
var isLoggedIn = computed(() => userStore.isLoggedIn);
var isUserLoading = computed(() => userStore.isUserLoading);
var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);

//var isTrainingLoading = computed(() => trainingStore.isTrainingLoading);
var trainingPrograms = computed(() =>
  trainingStore.portalTrainingPrograms.filter(
    (t) =>
      t.isActive &&
      user.value?.permissions?.find((p) => p.trainingProgramId === t.trainingProgramId)
  )
);

var completedModules = computed(() =>
  trainingPrograms.value.flatMap((p) =>
    (p.trainingModules ?? []).filter(
      (m) =>
        m.isActive &&
        user.value?.results?.find(
          (r) =>
            r.trainingModuleId == m.trainingModuleId && r.isPassingScore && !r.isExpired
        )
    )
  )
);

onMounted(loadData);
watch(property, loadData);
watch(isUserLoadedFromServer, redirectIfNotLoggedIn);
watch(isUserLoading, redirectIfNotLoggedIn);

function redirectIfNotLoggedIn() {
  // If user loading attempt is complete
  //    and we're still not logged in,
  //  then redirect to login page
  if (
    property.value &&
    userStore.isUserLoadedFromServer &&
    !userStore.isUserLoading &&
    !isLoggedIn.value
  ) {
    console.log("Training redirecting to login page. isLoggedIn=" + isLoggedIn.value);
    router.push(`/${property.value.siteCode}/login?returnUrl=training`);
    // } else {
    //   console.log(
    //     "Training NOT to login page. isLoggedIn=" +
    //       isLoggedIn.value +
    //       ", userLoadcomplete=" +
    //       userStore.isUserLoadedFromServer
    //   );
  }
}

async function loadData() {
  //console.log("Training page> Load data");
  if (property.value?.portalId) {
    redirectIfNotLoggedIn();
    await trainingStore.getTrainingProgramsByPortal(property.value.portalId);
    console.log("Training Data loaded", trainingPrograms.value);
  } else {
  }
}

let moduleClick = function (module: TrainingModuleDTO) {
  router.push(
    `/${property.value?.siteCode}/training/module/${module.trainingModuleId}/video`
  );
};
</script>

<style>
.font-module {
  font-size: 1rem;
}
</style>
